import { fork } from 'redux-saga/effects';
import { watchLoadUser } from './LoadUser';
import { watchSaveUserData, watchSaveUserStatusAction } from './SaveUserData';

export const UserSagas = [fork(watchLoadUser), fork(watchSaveUserData), fork(watchSaveUserStatusAction)];
